import { capitalizeFirstLetter } from '@repo/ui/utils';
import { buildWebsiteUrl } from '@repo/utils/url';
import { StripePaymentElementOptions } from '@stripe/stripe-js';

import {
  planSelectionStoreSelector,
  usePlanSelectionStore,
} from '../../../../stores/planSelectionStore';
import { NextChargeData } from '../../hooks/types';

const isSameDate = (date?: Date): boolean => {
  const currentDate = new Date();
  if (!date) {
    return false;
  }

  const nextChargeDate = new Date(date);
  return (
    currentDate.getDate() === nextChargeDate.getDate() &&
    currentDate.getMonth() === nextChargeDate.getMonth() &&
    currentDate.getFullYear() === nextChargeDate.getFullYear()
  );
};

const usePlanPaymentDetails = (
  nextCharge: NextChargeData | null
): { options: StripePaymentElementOptions } => {
  const plan = usePlanSelectionStore(planSelectionStoreSelector.plan);
  const yearly = usePlanSelectionStore(planSelectionStoreSelector.yearly);

  const applePayLabel = `${capitalizeFirstLetter(plan.toLowerCase())} plan`;

  return {
    options: {
      applePay: nextCharge?.value.amount
        ? {
            recurringPaymentRequest: {
              paymentDescription: applePayLabel,
              managementURL: buildWebsiteUrl('/user/settings/subscription'),
              regularBilling: {
                amount: nextCharge?.value.amount,
                label: applePayLabel,
                recurringPaymentIntervalUnit: yearly ? 'year' : 'month',
                recurringPaymentStartDate: isSameDate(nextCharge?.date)
                  ? undefined
                  : nextCharge?.date,
              },
            },
          }
        : undefined,
    },
  };
};

export default usePlanPaymentDetails;
